export const PRODUCTION_TRACKING_COLUMNS = [
  {
    name: 'empNo',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: 'Team',
    options: {
      display: true,
      sort: true
    }
  },

  {
    name: 'mtd',
    label: 'MTD Tracking Production',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'ytd',
    label: 'YTD Tracking Production',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'name',
  direction: 'asc'
};
